<template>
  <div>
    <!-- 存储网关 -->
    <div class="storagegateways">
      <Row :gutter="10">
        <!-- <Col span="4" style="padding-left:10px">
          <Select v-model="accountType" filterable :placeholder="$t('permission_configuration_management.group.checkByAccountType')"  @on-change="searchAccountType()" :transfer="true">
            <Option value="" selected>{{$t('permission_configuration_management.common.all')}}</Option>
            <Option :value="item.id" v-for="item in accountTypeList" :key="item.name">{{item.name}}</Option>
          </Select>
        </Col> -->
        <Col span="4">
          <Input
            search
            v-model="accountName"
            :placeholder="
              $t('permission_configuration_management.group.checkByAccountName')
            "
            @on-search="searchAccountName()"
          />
        </Col>
        <Col span="4">
          <Input
            search
            v-model="storageGatewayId"
            :placeholder="$t('permission_configuration_management.resourcePermission.searchByStorageGatewayId')"
            @on-search="searchStorageGatewayId()"
          />
        </Col>
        <Col span="4">
          <Button type="primary" @click="handleShowAdd">{{
            this.$t(
              "permission_configuration_management.group.addStorageGateway"
            )
          }}</Button>
        </Col>
      </Row>
    </div>
    <Modal
      v-model="modal"
      :title="$t('permission_configuration_management.group.addStorageGateway')"
      width="900px;"
      :loading="modalLoading"
      :ok-text="$t('alarms.common.add')"
      :mask-closable="false"
      :closable="false"
    >
      <Form
        :model="resourceForm"
        :label-width="100"
        ref="resourceForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <!-- 云平台 -->
          <!-- <Col span="6">
              <FormItem :label="$t('permission_configuration_management.group.cloudPlatform')" prop="accountTypeSearchKey" :label-width="60">
                  <Select v-model="resourceForm.accountTypeSearchKey" filterable @on-change="changeAccountTypeSearchKey(resourceForm.accountTypeSearchKey)" :transfer="true" placeholder="">
                      <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </FormItem>
          </Col> -->
          <Col span="6">
            <!-- 账户 -->
            <FormItem
              :label="$t('permission_configuration_management.group.account')"
              prop="account"
              :label-width="50"
            >
              <Select
                v-model="resourceForm.account"
                @on-change="changeAccount(resourceForm.account)"
                multiple
                :max-tag-count="1"
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Checkbox
                  v-model="singleAccount"
                  @on-change="selectAccountAll"
                  style="display: block;text-align:right;"
                  >{{ $t("alarms.common.allSelected") }}</Checkbox
                >
                <Option
                  :value="item.id"
                  @click.native="getMoreParams(item)"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6" style="z-index: 200" v-if="platformType != 3">
            <!-- 存储区域 -->
            <FormItem
              :label="$t('permission_configuration_management.group.region')"
              prop="region"
              :label-width="50"
            >
              <Select
                @on-change="changeRegion(resourceForm.region)"
                v-model="resourceForm.region"
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float:right;"
            v-show="isShowSearch"
            @click="searchStorageGatewaysInput()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="cancel('resourceForm')">{{
          $t("permission_configuration_management.common.cancel")
        }}</Button>
        <Button
          type="primary"
          @click="handleSubmit('resourceForm')"
          :loading="addloading"
          :disabled="isDisable"
          >{{
            $t("permission_configuration_management.common.confirm")
          }}</Button
        >
      </div>
      <Table
        :no-data-text="$t('common.noData')"
        ref="selection"
        :columns="columns4"
        :loading="loading"
        :data="queryAccountStorageGatewaysData"
        :height="400"
        @on-selection-change="getSelection"
      ></Table>
    </Modal>
    <table-storage-gateways
      ref="tableStorageGatewaysChild"
      :getAccountType="getAccountType"
    ></table-storage-gateways>
  </div>
</template>

<script>
import { getCookie } from "../../../../utils/cookieUtil.js";
import TableStorageGateways from "../resource_permission/TableStorageGateways";

const tableStorageGateways = TableStorageGateways;
export default {
  name: "AddStorageGateways",
  components: {
    TableStorageGateways
  },
  props: ["getAccountType"],
  data() {
    return {
      platformType: "",
      accountType: "",
      accountName: "",
      storageGatewayId: "",
      privateIp: "",
      selection: [],
      accountTypeList: [],
      modal: false,
      modalLoading: true,
      loading: false,
      addloading: false,
      isDisable: true,
      accountList: [],
      regionList: [],
      isShowSearch: false,
      singleAccount: false,
      resourceForm: {
        accountTypeSearchKey: "",
        account: [],
        region: "",
        tags: ""
      },
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectCloudPlatform"),
            trigger: "change",
            type: "number"
          }
        ],
        account: [
          {
            required: true,
            message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectAccountName"),
            trigger: "change",
            type: "array"
          }
        ],
        region: [
          { required: true, message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectStorageRegion"), trigger: "change" }
        ]
      },
      columns4: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.storageGatewayName"
          ),
          key: "storageGatewayName",
          width: "120px"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.storageGatewayID"
          ),
          key: "storageGatewayId"
        }
      ],
      queryAccountStorageGatewaysData: [],
      newQueryAccountStorageGatewaysDataList: []
    };
  },
  methods: {
    // 按账户类型筛选
    searchAccountType: function() {
      eventBus.$emit("accountType", this.accountType);
      tableStorageGateways.methods.showAllStorageGateway();
    },
    // 按账户名称筛选
    searchAccountName: function() {
      eventBus.$emit("accountName", this.accountName);
      tableStorageGateways.methods.showAllStorageGateway();
    },
    // 按网关ID搜索
    searchStorageGatewayId: function() {
      eventBus.$emit("storageGatewayId", this.storageGatewayId);
      tableStorageGateways.methods.showAllStorageGateway();
    },
    // 父组件调用子组件table内的方法
    queryStorageGatewaysByGroupId() {
      this.$refs.tableStorageGatewaysChild.queryStorageGatewaysByGroupId();
    },
    // 云平台
    queryCloudPlatforms: function() {
      this.$api.account
        .queryCloudPlatforms("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    },
    // 切换云平台
    changeAccountTypeSearchKey: function() {
      this.resourceForm.account = [];
      this.resourceForm.region = "";
    },
    handleShowAdd() {
      this.modal = true; // 清空表格
      this.queryAccountStorageGatewaysData = [];
      this.isShowSearch = true;
      this.selectAccountByCloudPlatform();
    },
    //查询账号
    selectAccountByCloudPlatform: function() {
      this.$api.groupAccountRelation
        .getAccountByGroupIdAndCloudPlatform({
          groupId: this.$route.query.id,
          accountType: this.getAccountType
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    selectAccountAll() {
      this.resourceForm.account = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.resourceForm.account.push(item.id);
        });
      } else {
        this.resourceForm.account = [];
      }
    },
    // 切换账户
    changeAccount: function(val) {
      if (this.resourceForm.account.length == 0) {
        return;
      }
      // 清空表格
      this.queryAccountStorageGatewaysData = [];
      this.resourceForm.region = "";
      this.isShowSearch = true;
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      this.$api.account
        .queryAccountRegionsByAccountIds(
          "accountIds",
          this.resourceForm.account
        )
        .then(res => {
          this.regionList = res.data;
        });
    },
    //获取自己要的属性
    getMoreParams: function(params) {
      //账号类型
      this.platformType = params.type;
    },
    // 切换存储区域
    changeRegion: function() {
      this.queryAccountStorageGatewaysData = [];
      this.isShowSearch = true;
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryAccountStorageGatewaysDataList = [];
      for (let i = 0; i < this.selection.length; i++) {
        const TableQueryAccountStorageGatewaysDataCopy = new Object();
        TableQueryAccountStorageGatewaysDataCopy.storageGatewayId = this.selection[
          i
        ].storageGatewayId;
        TableQueryAccountStorageGatewaysDataCopy.storageGatewayName = this.selection[
          i
        ].storageGatewayName;
        TableQueryAccountStorageGatewaysDataCopy.region = this.selection[
          i
        ].region;
        TableQueryAccountStorageGatewaysDataCopy.accountId = this.selection[
          i
        ].accountId;
        this.newQueryAccountStorageGatewaysDataList.push(
          TableQueryAccountStorageGatewaysDataCopy
        );
      }

      // 选了数据 可以点击下一步
      if (this.newQueryAccountStorageGatewaysDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchStorageGatewaysInput: function() {
      this.loading = true;
      // 根据AccountId查询StorageGateway列表
      this.$api.storageGateway
        .queryStorageGatewayByAccountId({
          region: this.resourceForm.region,
          accountIds: this.resourceForm.account,
          groupId: this.$route.query.id
        })
        .then(res => {
          this.queryAccountStorageGatewaysData =
            res.data.resourceStoragegatewayDTOs;
          this.loading = false;
        });
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加storageGateway
          this.addloading = true;
          this.$api.groupStorageGatewayRelation
            .createGroupStorageGatewayRelation({
              groupId: this.$route.query.id,
              resourceStoragegatewayDTOList: this
                .newQueryAccountStorageGatewaysDataList
            })
            .then(res => {
              setTimeout(() => {
                tableStorageGateways.methods.showAllStorageGateway();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.queryAccountStorageGatewaysData = [];
                this.newQueryAccountStorageGatewaysDataList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
                this.singleAccount = false;
                this.accountList = [];
                this.regionList = [];
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    // 取消
    cancel: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.singleAccount = false;
      this.accountList = [];
      this.regionList = [];
      this.queryAccountStorageGatewaysData = [];
      this.newQueryAccountStorageGatewaysDataList = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style scoped>
.storagegateways {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/AddStorageGateways.vue